import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  query AgentKnowledgeBaseFiles(
    $tenantId: ID!
    $zoneId: ID!
    $agentId: String!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        agentKnowledgeBaseFiles(agentId: $agentId) {
          knowledgeBaseId
          s3Uri
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AgentKnowledgeBaseFilesQuery,
    readonly ents.core.agent.KnowledgeBase.File[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'agentKnowledgeBaseFiles',
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            knowledgeBaseId: graphql.transformers.OUT.nonNull(
              transformers.PASS_THROUGH,
            ),
            s3Uri: graphql.transformers.OUT.nonNull(transformers.PASS_THROUGH),
          }),
          { onNullish: 'remove' },
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.AgentKnowledgeBaseFilesQuery,
  readonly ents.core.agent.KnowledgeBase.File[],
  graphql.schema.AgentKnowledgeBaseFilesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
